/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-06-01 14:49:34
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2022-10-26 16:23:55
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\Organization\departmentHomePage\api\index.js
 */
import request from '@/utils/req.js';

//科室主页列表接口
export function departmentList(params) {
    return request.post('/admin/open-department-config/page',params)
}
//科室主页列表启用禁用
export function departUpdateStatus(params) {
    return request.put(`/admin/open-department-config/updateStatus/${params}`);
}
//获取医院列表
export function departHospitalList(params) {
    return request.post('/admin/hospital/list',params)
}
//根据选择医院获取科室列表
export function departList(params) {
    return request.post('/admin/open-department/listAddSign',params)
}
//获取科室主页配置详情
export function getDepartmentDetail(params) {
    return request.get(`/admin/open-department-config/${params}`)
}
//科室病种
export function findDiseaseType(params) {
    return request.get(`/admin/disease-type/findDiseaseTypeByCondition/${params}`)
}
//根据机构科室、团队获取病种
export function findDiseaseTypeByother(params) {
    return request.post(`/admin/disease-type/findDiseaseTypeByCondition/focusField`,params)
}
//获取病种对应医生
export function doctorTeamPage(params) {
    return request.post('/admin/open-department-doctor-team-mapping/page',params)
}
//上移动
export function moveUp(params) {
    return request.get(`/admin/open-department-doctor-team-mapping/moveUp/${params}`)
}

//下移动
export function moveDown(params) {
    return request.get(`/admin/open-department-doctor-team-mapping/moveDown/${params}`)
}
//科室配置保存
export function saveOrUpdateConfig(params) {
    return request.post('/admin/open-department-config/saveOrUpdateConfig',params)
}




